// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__6DoII","resendInfoText":"OnGoingPaymentBox_resendInfoText__1PFki"};